import { render, staticRenderFns } from "./AppStrategyidSetting.vue?vue&type=template&id=605fff34&scoped=true"
import script from "./AppStrategyidSetting.vue?vue&type=script&lang=js"
export * from "./AppStrategyidSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605fff34",
  null
  
)

export default component.exports